<template>
  <div>
    <el-form label-width="130px" :model="form" :rules="rules" ref="form">

      <el-form-item label="活动开始时间" prop="startTime">
        <el-date-picker
          v-model="form.startTime"
          type="date"
          placeholder="选择开始时间"
          value-format="yyyy-MM-dd"
          :picker-options="startTimeOption"
          @change="changeStartTime">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="活动结束时间" prop="endTime">
        <el-date-picker
          v-model="form.endTime"
          type="date"
          placeholder="选择结束时间"
          value-format="yyyy-MM-dd"
          :picker-options="endTimeOption"
          @change="changeEndTime">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="选择生效天" prop="days">
        <el-checkbox-group v-model="form.days">
          <el-checkbox v-for="(item, index) in weekDay" :key="index + 1" :label="index + 1" name="day" :disabled="!canCheckDays.includes(index + 1)">{{item}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="每日秒杀时段" v-if="activeType === 9">
        <div v-for="(item, index) in form.activeTimes" :key="index" class="activeTime">
          <!-- <el-time-picker
            is-range
            v-model="form.activeTimes[index]"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围">
          </el-time-picker> -->
          <el-time-select
            placeholder="开始时间"
            v-model="form.activeTimes[index][0]"
            style="width: 150px"
            :picker-options="{
              start: '00:00',
              step: '01:00',
              end: '23:00'
            }">
          </el-time-select>
          至
          <el-time-select
            placeholder="结束时间"
            v-model="form.activeTimes[index][1]"
            style="width: 150px"
            :picker-options="{
              start: '00:59',
              step: '01:00',
              end: '23:59',
              minTime: form.activeTimes[index][0]
            }">
          </el-time-select>
          <el-button class="text-btn" type="text" @click="removeActiveTime(index)" v-if="form.activeTimes.length > 1">删除</el-button>
          <el-button class="text-btn" type="text" @click="addActiveTime" v-if="form.activeTimes.length < 3 && index === form.activeTimes.length - 1">添加</el-button>
        </div>
      </el-form-item>

      <el-form-item label="投放渠道" required>
        <el-radio-group v-model="form.pushChannel" @change="changePushChannel">
          <el-radio v-for="(item, index) in pushChannelList" :label="index" :key="index">{{item}}</el-radio>
        </el-radio-group>
        <el-popover
          placement="right"
          width="350"
          trigger="hover"
          content="第三方平台指与团油合作的车主平台。若选择投放到第三方平台，则车主通过这些平台在团油合作油站加油，也可以享受优惠。">
          <span slot="reference" class="tipsColor"> <query-tips-icon /> </span>
        </el-popover>
      </el-form-item>

      <el-form-item label="用户类型" required>
        <el-radio-group v-model="form.userType" @change="changeUserType">
          <!-- <el-radio v-for="item in userTypeList" :key="item.value" :label="item.value" :disabled="!userRange.includes(item.value)">{{ item.label }}</el-radio> -->
          <el-radio :label="-1" :disabled="!userRange.includes(-1)">不限制</el-radio>
          <template v-if="form.pushChannel === 0">
            <el-radio :label="0" :disabled="!userRange.includes(0)">油站新客户</el-radio>
            <el-radio :label="1" :disabled="!userRange.includes(1)">油站老客户</el-radio>
          </template>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="活动油号" prop="rebate">
        <el-radio-group v-model="form.oilNo">
          <el-radio v-for="item in oilNoList" :key="item.oilNo" :label="item.oilNo">{{ item.oilNo }}#</el-radio>
        </el-radio-group>
        <div class="column-space" v-if="form.oilNo">
          <span class="oil-name">{{ form.oilNo }}# 油品</span>
          <span class="text-space">追加让利</span>
          <el-input-number v-model="form.rebate" :step="1" :max="maxRange" :min="minRange" :disabled="!maxRange && !minRange" :placeholder="rebateRange" :precision="2" controls-position="right" style="width: 200px"></el-input-number> %
          <span class="down-price">降价参考 <span>{{downPrice}}</span> 元/升</span>
          <el-popover
            placement="right"
            width="200"
            trigger="hover"
            content="具体降价金额将根据枪价实时调整">
            <span slot="reference" class="tipsColor"> <query-tips-icon /> </span>
          </el-popover>
        </div>
      </el-form-item>

      <!-- <el-form-item label="是否资源位置顶" required>
        <el-radio-group v-model="form.isLocationTop" @change="changeLocationTop">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
        <el-popover
          placement="right"
          trigger="hover">
          <img class="demo-img" :src="demoUrl" alt="">
          <span class="demo-text" slot="reference">查看示例</span>
        </el-popover>
        <div class="column-space"  v-if="form.isLocationTop">
          <span class="oil-name">置顶范围</span>
          <el-select class="text-space" v-model="form.distance">
            <el-option v-for="item in distanceList" :label="item + 'KM'" :key="item" :value="item"></el-option>
          </el-select>
        </div>
      </el-form-item> -->

    </el-form>
    <div class="btn-groups">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import config from './config'

export default {
  name: 'active-form',
  props: ['activeType', 'oilNoList', 'wallConfig'],
  data () {
    let _this = this
    const checkEndTime = (rule, value, callback) => {
      if (dayjs(this.form.startTime).format('YYYY-MM-DD 00:00:00').valueOf() > dayjs(this.form.endTime).format('YYYY-MM-DD 23:59:59').valueOf()) {
        callback(new Error('结束时间不能小于开始时间'))
      } else {
        callback()
      }
    }
    return {
      ...config,
      maxRange: 0,
      minRange: 0,
      distanceList: [],
      rebateRange: '',
      userRange: [],
      demoUrl: _this.activeType === 7 ? 'https://web.nlktj.com/ty/merchant/image/activePage/daySpetialActive.png' :
      'https://web.nlktj.com/ty/merchant/image/activePage/limitShopActive.png',
      form: {
        startTime: '',
        endTime: '',
        days: [1, 2, 3, 4, 5, 6, 7],
        userType: -1,
        oilNo: '',
        isLocationTop: 0,
        distance: null,
        pushChannel: 0,
        activeTimes: [[]],
        reductionAmount: 0,
      },
      canCheckDays: [1, 2, 3, 4, 5, 6, 7],
      rules: {
        startTime: [{ required: true, message: '请选择活动开始时间', trigger: 'change' }],
        endTime: [
          { required: true, message: '请选择活动结束时间', trigger: 'change' },
          { validator: checkEndTime, trigger: 'change' }
        ],
        days: [{ type: 'array', required: true, message: '请选择至少一个生效天', trigger: 'change' }],
        oilNo: [{ required: true, message: '请选择活动油号', trigger: 'blur' }],
        rebate: [{ required: true, message: '请输入追加让利', trigger: 'blur' }]
      },
      startTimeOption: {
        disabledDate(time) {
          return dayjs(time).valueOf() <= dayjs().valueOf()
        }
      },
      endTimeOption: {
        disabledDate(time) {
          let startTime = _this.form.startTime ? dayjs(_this.form.startTime).valueOf() : dayjs().valueOf()
          // 结束时间应大于开始时间，且90天内可选
          return dayjs(time).valueOf() < startTime || dayjs(time).valueOf() > startTime + 89 * 24 * 3600 * 1000
        }
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
    downPrice () {
      let price = this.oilNoList.find(item => item.oilNo === this.form.oilNo)
      return  (price.priceGun * this.form.rebate / 100 || 0).toFixed(2)
    }
  },
  watch: {
    'form.userType': function () {
      this.setRebateData()
    }
  },
  methods: {
    setRebateData () {
      let rebate = this.wallConfig.find(item => item.userRange === this.form.userType)
      this.distanceList = rebate.wallConfig
      this.form.distance = this.distanceList[0]
      this.maxRange = rebate.maxDiscount
      this.minRange = rebate.minDiscount
      this.rebateRange = `让利范围${this.minRange}～${this.maxRange}`
    },
    save () {
      //  天天特价埋点
      if (this.activeType === 7) {
        this.$track.clickEvent('天天特价-添加规则', 1632832580, { tysj_trade_type: 1 })
      }
      // 限时秒杀活动，需要校验每日秒杀时段，并格式化参数
      if (this.activeType === 9) {
        for (let i = 0; i < this.form.activeTimes.length; i++) {
          let item = this.form.activeTimes[i]
          if (!item[0] || !item[1]) {
            this.$message.error('每日秒杀时段不能为空')
            return
          }
          if (item[0].split(':')[0] > item[1].split(':')[0]) {
            this.$message.error('每日秒杀时间段开始时间不能大于结束时间')
            return
          }
          item[0] = item[0].split(':')[0] + ':00:00'
          item[1] = item[1].split(':')[0] + ':59:59'
        }
      }
      // 校验数据，派发给父组件
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('addRule', {
            ...this.form,
            startTime: dayjs(this.form.startTime).format('YYYY-MM-DD 00:00:00'),
            endTime: dayjs(this.form.endTime).format('YYYY-MM-DD 23:59:59'),
            reductionAmount: this.downPrice,
            days: this.form.days.join(',')
          })
        }
      })
    },
    cancel () {
      //  天天特价埋点
      if (this.activeType === 7) {
        this.$track.clickEvent('天天特价-添加规则', 1632832580, { tysj_trade_type: 0 })
      }
      this.$emit('cancel', false)
    },
    addActiveTime () {
      this.form.activeTimes.push([])
    },
    removeActiveTime (i) {
      this.form.activeTimes.splice(i, 1)
    },
    changeLocationTop (val) {
      if (!val) this.form.distance = null
    },
    changeStartTime () {
      this.form.endTime = ''
      this.changeActiveTime()
    },
    changeEndTime () {
      this.changeActiveTime()
    },
    changeActiveTime (whetherEdit) {
      if (this.form.startTime && this.form.endTime) {
        const diff = dayjs(this.form.endTime).diff(dayjs(this.form.startTime), 'day')
        if (diff + 1 < 7) {
          let startTime = dayjs(this.form.startTime).day()
          startTime = startTime === 0 ? 7 : startTime
          let endTime = dayjs(this.form.endTime).day()
          this.canCheckDays = []
          if (startTime <= endTime) {
            while (startTime <= endTime) {
              this.canCheckDays.push(startTime)
              startTime++
            }
          } else {
            let checkDays = []
            while (++endTime < startTime) {
              checkDays.push(endTime)
            }
            this.canCheckDays = [1,2,3,4,5,6,7].filter(item => !checkDays.includes(item))
          }
          this.form.days = whetherEdit ? this.form.days.split(',').map(item => Number(item)) : this.canCheckDays
        } else {
          if (whetherEdit) {
            this.canCheckDays = [1,2,3,4,5,6,7]
            this.form.days = this.form.days.split(',').map(item => Number(item))
          } else {
            this.form.days = this.canCheckDays = [1,2,3,4,5,6,7]
          }
        }
      }
    },
    changeUserType () {
      this.form.rebate = undefined
    },
    changePushChannel (val) {
      if (val !== 0) this.form.userType = -1
    }
  },
  mounted () {
    this.setRebateData()
    this.form.oilNo = this.oilNoList[0]?.oilNo
    this.userRange = this.wallConfig.map(item => item.userRange)
  }
}
</script>
<style lang="less" scoped>
  @import url('./form.less');
</style>
